import React, { useEffect, useState } from 'react';
import Herosection from './Herosection';
import Footer from './Footer';
import maps2 from '../../assets/maps2.svg';
import phone from '../../assets/phone.svg';
import mail from '../../assets/mail.svg';
import fbIcon from '../../assets/fb2.svg';
import instaIcon from '../../assets/fb3.svg';
import twitterIcon from '../../assets/fb4.svg';
import maps from '../../assets/maps.svg';
import Swal from 'sweetalert2';
import { useDashboard } from '../Context/Dashboardcontext';

const Contact = () => {
  const { sendQuery, loading, contactDetails, fetchContactDetails } = useDashboard();

  const [form, setForm] = useState({
    name: '',
    phone: '',
    email: '',
    subject: '',
    comment: '',
  });

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  useEffect(() => {
    fetchContactDetails();
  }, []);

  const validateForm = () => {
    const { name, phone, email, comment } = form;
    if (!name.trim() || !phone.trim() || !email.trim() || !comment.trim()) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please fill in all required fields.',
      });
      return false;
    }
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      Swal.fire({
        icon: 'warning',
        title: 'Validation Error',
        text: 'Please enter a valid email address.',
      });
      return false;
    }
   
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;

    try {
      await sendQuery(form);
      Swal.fire({
        icon: 'success',
        title: 'Success!',
        text: 'Your message has been sent.',
      });
      setForm({
        name: '',
        phone: '',
        email: '',
        subject: '',
        comment: '',
      });
    } catch (error) {
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'Something went wrong. Please try again.',
      });
    }
  };

  if (!contactDetails) return null; // or loader

  return (
    <>
      {/* <Herosection /> */}
      <div className="bg-black text-white px-4 md:px-12 py-16">
        <div className="text-center mb-12">
          <h2 className="text-[48px] font-semibold">Contact Us</h2>
          <p className="text-[28px] text-gray-300 leading-[1.1]">
            Most calendars are designed for teams.
            <br />
            Slate is designed for freelancers
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8">
          <div>
            <div className="grid grid-cols-1 sm:grid-cols-3 text-center mb-8">
              <div className="flex flex-col items-center">
                <img src={maps2} className="text-xl mb-2" />
                <p className="text-sm">{contactDetails.address}</p>
              </div>
              <div className="flex flex-col items-center mt-6 sm:mt-0">
                <img src={phone} className="text-xl mb-2" />
                <p className="text-sm">{contactDetails.customerCarePhone}</p>
              </div>
              <div className="flex flex-col items-center mt-6 sm:mt-0">
                <img src={mail} className="text-xl mb-4" />
                <p className="text-sm">{contactDetails.email}</p>
              </div>
            </div>

           <div className="w-full h-64 rounded overflow-hidden">
  <iframe
    src={contactDetails.mapLink}
    width="100%"
    height="100%"
    style={{ border: 0 }}
    allowFullScreen=""
    loading="lazy"
    referrerPolicy="no-referrer-when-downgrade"
    title="Company Location"
  ></iframe>
</div>


            <div className="flex space-x-4 mt-10 justify-start">
              {contactDetails.fb && <a href={contactDetails.fb} target="_blank" rel="noopener noreferrer"><img src={fbIcon} className="cursor-pointer" /></a>}
              {contactDetails.instagram && <a href={contactDetails.instagram} target="_blank" rel="noopener noreferrer"><img src={instaIcon} className="cursor-pointer" /></a>}
              {contactDetails.twitter && <a href={contactDetails.twitter} target="_blank" rel="noopener noreferrer"><img src={twitterIcon} className="cursor-pointer" /></a>}
            </div>
          </div>

          <div className="bg-white text-black p-6 rounded-xl shadow-lg">
            <h1 className="text-black text-[20px] font-inter text-center font-bold mb-4">
              Contact us
            </h1>

            <form className="space-y-4" onSubmit={handleSubmit}>
              <input
                type="text"
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your Name"
                className="w-full px-4 py-3 rounded-full border border-gray-300 focus:outline-none"
                required
              />
              <input
                type="text"
                name="phone"
                value={form.phone}
                onChange={handleChange}
                placeholder="Your Phone"
                className="w-full px-4 py-3 rounded-full border border-gray-300 focus:outline-none"
                required
              />
              <input
                type="email"
                name="email"
                value={form.email}
                onChange={handleChange}
                placeholder="Your Email"
                className="w-full px-4 py-3 rounded-full border border-gray-300 focus:outline-none"
                required
              />
              <input
                type="text"
                name="subject"
                value={form.subject}
                onChange={handleChange}
                placeholder="Subject"
                className="w-full px-4 py-3 rounded-full border border-gray-300 focus:outline-none"
              />
              <textarea
                rows="5"
                name="comment"
                value={form.comment}
                onChange={handleChange}
                placeholder="Your Message"
                className="w-full px-4 py-3 rounded-xl border border-gray-300 focus:outline-none"
                required
              />
              <button
                type="submit"
                className={`bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-full transition flex items-center justify-center`}
                disabled={loading}
              >
                {loading ? (
                  <svg
                    className="animate-spin h-5 w-5 text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                  >
                    <circle
                      className="opacity-25"
                      cx="12"
                      cy="12"
                      r="10"
                      stroke="currentColor"
                      strokeWidth="4"
                    ></circle>
                    <path
                      className="opacity-75"
                      fill="currentColor"
                      d="M4 12a8 8 0 018-8v8z"
                    ></path>
                  </svg>
                ) : (
                  'Send'
                )}
              </button>
            </form>
          </div>
        </div>
      </div>
      {/* <Footer /> */}
    </>
  );
};

export default Contact;
